import { render, staticRenderFns } from "./WebCam.vue?vue&type=template&id=437e84bc"
import script from "./WebCam.vue?vue&type=script&lang=js"
export * from "./WebCam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports